import { render, staticRenderFns } from "./Specialists.vue?vue&type=template&id=331d52e8&scoped=true&"
import script from "./Specialists.vue?vue&type=script&lang=js&"
export * from "./Specialists.vue?vue&type=script&lang=js&"
import style0 from "./Specialists.vue?vue&type=style&index=0&id=331d52e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331d52e8",
  null
  
)

export default component.exports